// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__BNCv_","danger":"badge_danger__3AJA6","primary":"badge_primary__O0w1P"};